import React from 'react'

const highlight = (text, query) => {
  if (!query || !text) return text
  const tokens = query.trim().split(/\s+/).filter(t => t.length > 1)
  if (!tokens.length) return text
  const re = new RegExp(`(${tokens.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'ig')
  const parts = text.split(re)
  return parts.map((p, i) => (re.test(p) ? <mark key={i}>{p}</mark> : <span key={i}>{p}</span>))
}

const SearchResults = ({ query, results, onSelect, chaptersByKey }) => {
  if (!query) return null
  if (!results.length) {
    return (
      <div className="hc-search-results hc-search-results--empty">
        <p>{I18n.t('help_center_modal.no_results_for')} <strong>{query}</strong></p>
        <p className="hc-search-results__hint">{I18n.t('help_center_modal.no_results_hint')}</p>
      </div>
    )
  }
  return (
    <div className="hc-search-results">
      <p className="hc-search-results__count">
        {I18n.t('help_center_modal.results_for')} <strong>{query}</strong> ({results.length})
      </p>
      <ul className="hc-search-results__list">
        {results.map(({ article, snippet }) => {
          const chapter = chaptersByKey[article.chapter]
          return (
            <li key={article.slug}>
              <button
                type="button"
                className="hc-search-results__item"
                onClick={() => onSelect(article.slug)}
              >
                <span className="hc-search-results__breadcrumb">{chapter ? chapter.title : article.chapter}</span>
                <span className="hc-search-results__title">{highlight(article.title, query)}</span>
                {snippet && <span className="hc-search-results__snippet">{highlight(snippet, query)}</span>}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default SearchResults
